<script lang="ts">
	import { deviceWidth } from '$lib/stores';
	import { AppBar } from '@skeletonlabs/skeleton';
	import AdminNavbar from './AdminNavbar.svelte';
	import Navbar from './Navbar.svelte';

	export let isAdmin: boolean;

	const menuBreak = 860,
		adminMenuBreak = 1024;
</script>

<AppBar
	class="py-2 px-7 {$$props.class}"
	gridColumns="grid-cols-3"
	slotDefault="place-self-center"
	slotTrail="place-content-end"
>
	<svelte:fragment slot="lead">
		<div class="flex items-center space-x-4">
			<a href="/"><img src="/logo.png" class="max-h-14" alt="Arbatel logo" /></a>
			{#if $deviceWidth > adminMenuBreak && isAdmin}
				<AdminNavbar />
			{/if}
		</div>
	</svelte:fragment>

	<a href="/" class="font-heading-token text-4xl !font-normal !no-underline">ARBATEL</a>

	<svelte:fragment slot="trail">
		<Navbar showMainLinks={$deviceWidth > menuBreak} />
	</svelte:fragment>

	<svelte:fragment slot="headline">
		<div class="flex gap-4 items-center flex-col mt-2 sm:place-content-around sm:mt-0 sm:flex-row">
			{#if $deviceWidth <= adminMenuBreak && isAdmin}
				<AdminNavbar />
			{/if}
			{#if $deviceWidth <= menuBreak}
				<Navbar showExtraLinks={false} />
			{/if}
		</div>
	</svelte:fragment>
</AppBar>
